import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Session from '../../../classes/Session/Session';
import Translator from '../../../classes/Translator/Translator';

const ProjectCardLogic = (props) => {
  const { language, translator } = Translator();
  const history = useHistory();
  const { project = {} } = props;
  const [values, setValues] = useState({
    project,
  });
  const [state, setState] = useState({
    raised: false,
    shadow: 1,
  });
  const goToProject = () => {
    history.push(`/projects/${values.project.id}`);
    window.scrollTo(0, 0);
    window.location.reload();
  };

  const handleInvest = (e) => {
    e.preventDefault();
    const has_session = new Session({}).hasSession();
    if (has_session) {
      return history.push(`/projects/${values.project.id}`);
    } else {
      return history.push('/login', {
        callback: `/projects/${values.project.id}`,
      });
    }
  };

  const goToProjects = (e) => {
    e.preventDefault();
    const has_session = new Session({}).hasSession();
    if (has_session) {
      return history.push(`/projects`);
    } else {
      return history.push('/login', {
        callback: `/projects`,
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setValues({
      ...values,
      project: props.project,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  return {
    goToProject,
    handleInvest,
    values,
    translator,
    state,
    setState,
    goToProjects,
    language,
  };
};

export default ProjectCardLogic;
